import { Palette, Printer, Sparkles, Sun } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const ICONS = { pantone: Palette, cmyk: Printer, foil: Sparkles, "spot-uv": Sun };

export const Finishes = ({ finishes }) => (
  <section id="finishes" className="relative py-28 sm:py-36 overflow-hidden" data-testid="finishes-section">
    <div className="absolute inset-0 opacity-[0.07]">
      <img
        src="https://images.unsplash.com/photo-1651862589463-076de32b52c4?crop=entropy&cs=srgb&fm=jpg&q=85"
        alt=""
        className="w-full h-full object-cover"
      />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>The print atelier</Eyebrow>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-5xl font-medium tracking-tight text-[#F5F3EF] max-w-2xl leading-[1.15]">
          Four finishes that make<br /> the surface <span className="foil-text italic">speak.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-px bg-white/5 border border-white/5 rounded-2xl overflow-hidden sm:grid-cols-2">
        {finishes.map((f, i) => {
          const Icon = ICONS[f.id] || Sparkles;
          return (
            <Reveal key={f.id} delay={i * 0.08} className="h-full">
              <div
                className="group relative bg-[#14171D] p-8 sm:p-10 h-full overflow-hidden transition-colors duration-500 hover:bg-[#1A1E27]"
                data-testid={`finish-${f.id}-card`}
              >
                {f.id === "foil" && <div className="absolute inset-0 foil-shimmer opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />}
                <div className="relative">
                  <div className="flex items-start justify-between">
                    <div className="w-11 h-11 rounded-full border border-amber-500/25 flex items-center justify-center text-[#D4AF37]">
                      <Icon size={18} />
                    </div>
                    <span className="font-mono-spec text-[10px] tracking-[0.2em] text-[#666F7D]">0{i + 1}</span>
                  </div>
                  <h3 className="mt-7 font-serif-display text-xl sm:text-2xl font-medium text-[#F5F3EF]">{f.name}</h3>
                  <p className="mt-1 font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#D9A76A]">{f.tagline}</p>
                  <p className="mt-4 text-sm text-[#A1A8B3] leading-relaxed">{f.description}</p>
                  <p className="mt-6 text-[12px] font-medium text-[#D4AF37]/90 border-t border-white/5 pt-4">{f.highlight}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
